/* ----------------------------------------------------
Imports
---------------------------------------------------- */

import { relativeTarget } from 'meteora';

/* ----------------------------------------------------
Tool tip functionality
---------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  // Find all the js-tooltip elements
  var tooltipElements = document.querySelectorAll('.js-tooltip') || false;
  var tooltips = [];

  // If there are tool tips on the page, loop the tool tip elements and create our tooltips array
  if (tooltipElements) for (var i = 0; i < tooltipElements.length; i++) tooltips.push(tooltipElements[i]);
  tooltips.forEach(function (tooltip) {
    // Create a tip object that hold all our tool tip components
    var tip = {
      container: tooltip,
      trigger: tooltip.querySelector('.js-tooltip--trigger') || false,
      target: tooltip.querySelector('.js-tooltip--target') || false
    };

    // If we have all the components
    if (tip.trigger && tip.target) {
      // When we click the trigger
      tip.trigger.addEventListener('click', function (e) {
        e.preventDefault();
        // Toggle the js-active class on the target
        tip.target.classList.contains('js-active') ? tip.target.classList.remove('js-active') : tip.target.classList.add('js-active');
      });

      // If we click away from the tip remove the class
      window.addEventListener('click', function (e) {
        if (!relativeTarget(e.target, tip.container)) tip.target.classList.remove('js-active');
      });
    }
  });
});